import script from "./WksMediaModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksMediaModal.vue?vue&type=script&setup=true&lang=ts"

import "./WksMediaModal.vue?vue&type=style&index=0&id=1524512d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1524512d"]])

export default __exports__